<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="invoiceClass"
      label-position="right"
      label-width="150px"
      class="form"
    >
      <el-form-item label="类目名称" prop="title">
        <el-input
          v-model="invoiceClass.title"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入类目名称"
        />
      </el-form-item>

      <el-form-item label="税率">
        <v-input-percentage
          v-model="invoiceClass.tax_rate"
          label="税率"
          prop="tax_rate"
          placeholder="请输入税率"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.invoiceClassList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config'
import { store } from '@/api/invoice-class';
import { toCent } from "@/filters";

export default {
  name: RouteConfig.invoiceClassAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    invoiceClass: {
      title: '',
      tax_rate: 0,
    },
    rules: {
      title: [{ required: true, message: '请输入类目名称', trigger: 'change' }],
    },
  }),
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const postData = { ...this.invoiceClass };
        postData.tax_rate = toCent(postData.tax_rate);
        this.isSaving = true;
        const { isError } = await store(postData);
        this.isSaving = false;
        if (!isError) RouteConfig.invoiceClassList.push();
      });
    },
  },
};
</script>
